// extracted by mini-css-extract-plugin
export default {"anchors":"footer_anchors__TSJyA","secondAnchors":"footer_secondAnchors__Gmfqo","anchor":"footer_anchor__X46B1","anchor2":"footer_anchor2__8U-AH","navbrand":"footer_navbrand__sa+L3"};